import { useState } from "react";
import axios from "axios";
import styles from "./UserOptions.module.css";
import FacebookLogin from "@greatsumini/react-facebook-login";
import { useGoogleLogin } from "@react-oauth/google";
import { FaFacebookF } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import MicrosoftButton from "./MicrosoftButton";

const UserOptions = (props) => {
  const guestHandler = () => {
    props.onUserOption('guest');
  };
  const registeredUserHandler = () => {
    props.onUserOption('registered-user');
  };
  const newUserHandler = () => {
    props.onUserOption('new-user');
  };
  const contactUsHandler = () => {
    props.onUserOption('contact-us');
  };
  
  const [userData, setUserData] = useState({
    gmail: "",
    firstname: "",
    lastname: "",
  });
  
  const handleGoogleError = () => {
    console.log("Google login Failed");
  };

  const googleLogin = useGoogleLogin({
    scope: "openid email profile",
    onSuccess: async (tokenResponse) => {
      try {
        console.log("Google token response:", tokenResponse);

        const userInfoResponse = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          },
        );

        const profile = userInfoResponse.data;
        console.log("Google user profile:", profile);

        const newUserData = {
          gmail: profile.email || "",
          firstname: profile.given_name || "",
          lastname: profile.family_name || "",
          provider_user_id: profile.sub || "",
        };

        setUserData(newUserData);
        console.log("Userdata:", newUserData);

        const { data } = await axios.post(
          "php/sign_in/googleSignin.php",
          newUserData,
          {
            headers: {
              "Content-Type": "application/json",
            },
            withCredentials: true,
          },
        );

        console.log("response data:", data);

        if (data?.status === "success") {
          props.onGoogleSignin({
            method: "google",
            callname: data.callname,
          });
        } else {
          throw new Error(data?.message || "Unexpected response from server.");
        }
      } catch (error) {
        console.error("Google login error:", error);

        let message = "Please retry or use another method.";

        if (error.response) {
          // Server responded (4xx / 5xx)
          const status = error.response.status;
          const serverMessage = error.response.data?.message;

          if (status === 401) {
            message = serverMessage || "Unauthorized. Please try again.";
          } else if (status === 500) {
            message = serverMessage || "Server error. Please try again later.";
          } else {
            message = serverMessage || `Request failed (${status}).`;
          }
        } else if (error.request) {
          // No response from server
          message = "Network error. Check your internet connection.";
        } else if (error.message) {
          // Thrown manually or other error
          message = error.message;
        }

        alert(message);
      }
    },
    
    onError: handleGoogleError,
  });

  const splitFacebookName = (fullName = "") => {
    const normalized = fullName.trim().replace(/\s+/g, " ");
    if (!normalized) {
      return { firstname: "", lastname: "" };
    }

    const parts = normalized.split(" ");
    return {
      firstname: parts[0] || "",
      lastname: parts.slice(1).join(" ") || "",
    };
  };

  const handleFacebookSuccess = async (response) => {
    try {
      console.log("Facebook profile response:", response);

      const { firstname, lastname } = splitFacebookName(response.name);

      const email =
        typeof response.email === "string" && response.email.trim()
          ? response.email.trim().toLowerCase()
          : response.id
            ? `${response.id}@facebook.com`
            : "";

      if (!email) {
        alert("Facebook did not return a valid email or user ID.");
        return;
      }

      const newUserData = {
        email,
        firstname,
        lastname,
        provider_user_id: response.id || "",
      };

      setUserData(newUserData);
      console.log("newUserData:", newUserData);

      const res = await axios.post(
        "php/sign_in/facebookSignin.php",
        newUserData,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        },
      );

      console.log("Server response:", res.data);

      if (res.data?.status !== "success") {
        throw new Error(res.data?.message || "Facebook sign-in failed.");
      }

      props.onFacebookSignin({
        method: "facebook",
        callname: res.data.callname || firstname || "User",
      });
    } catch (error) {
      console.error("Facebook sign-in error:", error);

      const message =
        error.response?.data?.message ||
        error.message ||
        "Please retry or use another method.";

      alert(`Facebook sign-in failed. ${message}`);
    }
  };

  const handleFacebookError = (error) => {
    console.error("Facebook login error:", error);
    alert("Facebook sign-in was not completed. Please retry.");
  };

  const handleMicrosoft = (userData) => {
    props.onMicrosoftSignin(userData);
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Please select your option</h2>
      </header>
      <div className={styles.btnDiv}>
        <button
          className={styles.bgBlue}
          type="button"
          onClick={registeredUserHandler}
        >
          Sign in
        </button>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={newUserHandler}
        >
          Sign up
        </button>
        <button className={styles.bgBlack} type="button" onClick={guestHandler}>
          Guest
        </button>
      </div>
      <header>
        <h3>Or Sign in with:</h3>
      </header>
      <div className={styles.btnDiv}>
        <button
          className={styles.googleBtn}
          type="button"
          onClick={() => googleLogin()}
        >
          Google
          <FcGoogle size={20} />
        </button>
        <FacebookLogin
          appId="978349808465961"
          scope="email"
          onProfileSuccess={handleFacebookSuccess}
          onFail={handleFacebookError}
          render={({ onClick }) => (
            <button
              type="button"
              className={styles.facebookBtn}
              onClick={onClick}
            >
              Facebook
              <FaFacebookF size={20} color="#1877F2" />
            </button>
          )}
        />
        
        <MicrosoftButton onMicrosoftSignin={handleMicrosoft} /> 
        
      </div>
      <div className={styles.btnDiv}>
        <button
          className={styles.bgPurple}
          type="button"
          onClick={contactUsHandler}
        >
          Contact us
        </button>
        <button
          className={styles.bgRed}
          type="button"
          onClick={() => {
            window.location.reload(true);
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default UserOptions;